import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lean-postit-kpi',
  templateUrl: './lean-postit-kpi.component.html',
  styleUrls: ['./lean-postit-kpi.component.scss']
})

export class LeanPostitKpiComponent implements OnInit {


  @Input() title          : string = "Kpi";
  @Input() value          : number;
  @Input() value10        : string;
  @Input() value11        : string;
  @Input() value20        : string;
  @Input() value21        : string;
  @Input() value30        : string;
  @Input() value31        : string;
  @Input() value40        : string;
  @Input() value41        : string;
  @Input() unit           : string = "";
  @Input() value1Label    : string;
  @Input() value2Label    : string;
  @Input() value3Label    : string;
  @Input() value4Label    : string;
  @Input() status         : number;


 @Input() color           : string = "darkorange";   
 @Input() valuesFontSize	: number = 16;	
 @Input() valuesColor	    : string = "black";   
 @Input() valuesFontWeight: string = "bold"
 @Input() labelFontSize	  : number = 8;	
 @Input() labelFontWeight	: string = "regular";
  
  constructor() {
  }


  ngOnInit() {

  }



}
